module.exports = __webpack_public_path__ + "static/media/  (8).fce2c63b.jpg";